import '../assets/NcActionSeparator-Ct2RnclR.css';
import { createElementBlock, openBlock } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcActionSeparator"
};
const _hoisted_1 = {
  class: "action action-separator action--disabled",
  role: "separator"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", _hoisted_1);
}
const NcActionSeparator = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3e2324b7"]]);
export {
  NcActionSeparator as N
};
//# sourceMappingURL=NcActionSeparator-Doekl1NX.mjs.map
